import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AppLayout from "./components/layout/AppLayout";
import ProtectedRoute from "./shared/components/ProtectedRoute";
import LoginPage from "./modules/auth/LoginPage";
import { MODULES } from "./config/modules";
import { ROLES } from "./services/users";
import HomeDashboard from "./shared/components/HomeDashboard";
import OpportunityDetail from "./modules/contracts/components/OpportunityDetail";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Routes>
                  <Route path="/" element={<HomeDashboard />} />
                  {/* Contracts module with nested routes */}
                  <Route
                    path="contracts/opportunities/:id"
                    element={
                      <ProtectedRoute requiredRole={ROLES.USER}>
                        <OpportunityDetail />
                      </ProtectedRoute>
                    }
                  />
                  {MODULES.map((m) => (
                    <Route
                      key={m.id}
                      path={m.path.replace(/^\//, "")}
                      element={
                        <ProtectedRoute requiredRole={m.requiredRole}>
                          <m.component />
                        </ProtectedRoute>
                      }
                    />
                  ))}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AppLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
